import React, { Component } from "react";
import { Radio, Button } from "semantic-ui-react";
import "./address.css";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";

class ChnageAddress extends Component {

    state = {
        editAddress: 0,
        dialog: false,
        error: "",
        value: this.props.type,
        loading: false,
        errorDialog: false,
    };

    chooseAddress(id) {
        this.props.chooseAddress(id);
    }

    render() {
        return (
            <div>
                <b style={{ color: "blue", cursor: "pointer" }} onClick={() => this.setState({ dialog: true })}>Change</b>
                <Dialog
                    open={this.state.dialog}
                    fullWidth="md"
                    aria-labelledby="responsive-dialog-title"
                    onClose={ () => this.setState({ dialog: false })}
                >
                    <DialogTitle id="responsive-dialog-title">
                        Change Your Billing Address
                    </DialogTitle>
                    <DialogContent>
                        {
                            this.props.address.map((c) => {
                                return (
                                    <div style={{ display: "flex", gap: "10px", margin: "5%" }}>
                                        <Radio onClick={ () => this.props.setState('billingAddress', c.id) } checked={c.id == this.props.billingAddress} />
                                        <div style={{ padding: "2%", marginTop: "-3%" }}>
                                            <b>{c.name}</b><br/>
                                            <b>{`GSTIN : ${c.gstin}`}</b>
                                            <div>{c.mobile}</div>
                                            <div>{c.address}</div>
                                            <div>{c.city}, {c.state}, {c.pincode}</div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={ () => this.setState({ dialog: false })}>Close</Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

export default ChnageAddress;
